import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

	@Input() layout: any;
	@Input() responsive: boolean;

	pageInfo: any;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		private translateService: TranslateService
	) {
		this.router.events
			.filter(event => event instanceof NavigationEnd)
			.map(() => this.activatedRoute)
			.map(route => {
				while (route.firstChild) {
					route = route.firstChild;
				}
				return route;
			})
			.filter(route => route.outlet === 'primary')
			.subscribe(route => {
				const data = route.snapshot.data;
				this.pageInfo = cloneDeep(data);
				if (this.pageInfo.urls) {
					this.pageInfo.urls.forEach((page: any) => {
						if (page.url) {
							const params = route.snapshot.params;
							if (params) {
								Object.keys(params).forEach(k => {
									page.url = page.url.replace(`:${k}`, params[k]);
								});
							}
						}
					});
				}
				if (data['title']) {
					this.translateService.get(data['title']).subscribe(message => {
						this.titleService.setTitle(message);
					});
				} else {
					this.titleService.setTitle(data['title']);
				}
			});
	}

	ngOnInit() {}

}
